import { h, van } from "../lib/tb.js";
import * as api from "../lib/api.js";
import { Card, Button } from "../lib/components.js";
import { toast } from "../lib/toast.js";

export function ArticlesSection() {
  const running = van.state(false);
  const lines = van.state([]);
  const status = van.state(null); // { kind: 'ok'|'error', text }

  const logBox = h("pre.log", () =>
    h("code", lines.val.length ? lines.val.join("\n") : "Zatím žádný výstup."));

  const append = (line) => { lines.val = [...lines.val, line]; queueScroll(); };
  const queueScroll = () => requestAnimationFrame(() => { logBox.scrollTop = logBox.scrollHeight; });

  const run = async () => {
    if(running.val) return;
    running.val = true;
    status.val = null;
    lines.val = [];
    try {
      await api.regenerate((ev) => {
        if(ev.type === "log") append(ev.msg);
        else if(ev.type === "done") {
          const s = ev.stats || {};
          append("✓ " + (ev.msg || "Hotovo."));
          status.val = { kind: "ok", text: `Hotovo — ${s.created ?? 0} nových, ${s.updated ?? 0} upravených, ${s.hidden ?? 0} skrytých.` };
        } else if(ev.type === "error") {
          append("✗ Chyba: " + ev.msg);
          status.val = { kind: "error", text: ev.msg };
          toast.error(ev.msg);
        }
      });
    } catch(err) {
      append("✗ Chyba: " + err.message);
      status.val = { kind: "error", text: err.message };
      toast.error(err.message);
    } finally {
      running.val = false;
    }
  };

  return Card({
    title: "Články salonů",
    description: "Stáhne seznam salonů z Google My Maps a aktualizuje články na Shoptetu.",
  },
    h(".card__body", [
      h(".flex.items-center.gap-3", [
        Button({ onclick: run, disabled: running },
          () => running.val ? "Generuji…" : "Přegenerovat články salonů"),
        () => status.val
          ? h("span", { class: status.val.kind === "ok" ? "text-sm text-emerald-600" : "text-sm text-red-600" }, status.val.text)
          : null,
      ]),
      logBox,
    ]),
  );
}
